import { SIDEBAR_VIEWS, SIDEBAR_SAVED_TABS } from '../../lib/constants';
import * as sidebarNavigation from './sidebarNav';
import tail from 'lodash-es/tail';

export default {
  namespace: 'app',

  state: {
    showSidebar: true,
    loading: true,
    firebaseDone: false,
    hideCoords: false,
    sidebarView: {
      view: SIDEBAR_VIEWS.Library,
      metadata: {
        savedContentTab: SIDEBAR_SAVED_TABS.Collection,
        savedLayersTab: SIDEBAR_SAVED_TABS.Layers.All,
        savedLibraryTab: SIDEBAR_SAVED_TABS.Library.Layers,
      }
    },
    sidebarHasScrollBar: true,
    sidebarHistoryStack: [],
    sideBarScrollPosition: {
      collections: null,
      features: null,
      layers: null,
    },
    config: {}
  },

  effects: {
    ...sidebarNavigation,
  },

  reducers: {
    setHideCoords(state, { payload: hideStatus }) {
      return {
        ...state,
        hideCoords: hideStatus
      };
    },
    setGlobalLoading(state, { payload: loading }) {
      return {
        ...state,
        loading
      };
    },
    updateView(state, { payload = null }) {
      return {
        ...state,
        sidebarView: {
          ...state.sidebarView,
          view: payload
        }
      };
    },
    updateMetadata(state, { payload }) {
      return {
        ...state,
        sidebarView: {
          ...state.sidebarView,
          metadata: {
            ...state.sidebarView.metadata,
            ...payload
          }
        }
      };
    },
    gotoSidebar(state, { payload: view }) {
      let viewObj = view;
      /*
        #NOTE: Is this a little fragile? Seems to be working pretty fine.
        -- TJC - April 27, 2020
      */
      if (typeof view === 'string') {
        viewObj = {
          view
        };
      }

      return {
        ...state,
        showSidebar: !state.showSidebar ? true : state.showSidebar,
        sidebarView: {
          ...state.sidebarView,
          ...viewObj,
        }
      };
    },
    clearSidebarHistory(state, action) {
      return {
        ...state,
        sidebarHistoryStack: []
      };
    },
    pushSidebarHistory(state, { payload }) {
      return {
        ...state,
        sidebarHistoryStack: [payload, ...state.sidebarHistoryStack]
      };
    },
    popSidebarHistory(state, action) {
      return {
        ...state,
        sidebarHistoryStack: tail(state.sidebarHistoryStack)
      };
    },
    setFirebaseDone(state, { payload: status }) {
      return {
        ...state,
        firebaseDone: status
      };
    },
    setConfig(state, { payload: configObj }) {
      return {
        ...state,
        config: configObj
      };
    },
    setShowSidebar(state, { payload: setVal }) {
      return {
        ...state,
        showSidebar: setVal
      };
    },
    toggleSidebar(state, action) {
      return {
        ...state,
        showSidebar: !state.showSidebar
      };
    },
    setSideBarScrollPosition(state, { payload }) {
      return {
        ...state,
        sideBarScrollPosition: {
          ...state.sideBarScrollPosition,
          ...payload
        }
      };
    },
    setSidebarHasScrollBar(state, { payload }) {
      return {
        ...state,
        sidebarHasScrollBar: payload
      };
    },
  }
};
